import React, { ChangeEventHandler, FC, useEffect, useState } from "react";
import { TextField } from "@mui/material";
import {
  QuestionConfigDetailDto,
  QuestionConfigTranslationDto,
} from "@green0meter/api-client";

import { useQuestionEditorStore } from "@components/main/questions/QuestionEditor";

interface RichTextBoxInput {
  questionConfig: QuestionConfigDetailDto;
  setQuestionConfig: (questionConfig: QuestionConfigDetailDto) => void;
}

const RichTextBoxInput: FC<RichTextBoxInput> = ({
  questionConfig,
  setQuestionConfig,
}) => {
  const { language } = useQuestionEditorStore();
  const [translation, setTranslation] = useState<QuestionConfigTranslationDto>();

  const handleChangePlaceholder: ChangeEventHandler<
    HTMLInputElement | HTMLTextAreaElement
  > = (event) => {
    if (questionConfig) {
      setQuestionConfig({
        ...questionConfig,
        translations: questionConfig.translations.map((translation) =>
          translation.language === language
            ? { ...translation, placeholder: event.target.value }
            : translation,
        ),
      });
    }
  };

  useEffect(() => {
    if (questionConfig) {
      const currentTranslation = questionConfig.translations.find(
        (translation) => translation.language === language,
      );

      setTranslation(currentTranslation);
    }
  }, [questionConfig, language]);

  return (
    <TextField
      value={translation?.placeholder || ""}
      variant="filled"
      slotProps={{
        input: {
          onChange: handleChangePlaceholder,
          multiline: true,
          rows: 4,
        },
      }}
      placeholder="Placeholder for rich text input"
    />
  );
};

export default RichTextBoxInput;
